import { useEffect } from "react";
import { usePatchPropertyVehicleMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPropertyVehicleMutation";
import type { ClientPropertyVehicleDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getCarFormSchema } from "web_myplann/Portfolio/Forms/CarForm/carFormSchema";
import { mapPropertyToCarForm } from "web_myplann/Portfolio/Forms/CarForm/mapPropertyToCarForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditCarFormArgs = {
	propertyId: number;
	property: ClientPropertyVehicleDetailResponseDTO;
	detailRoute: string;
};

export const useEditCarForm = ({
	propertyId,
	property,
	detailRoute,
}: UseEditCarFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } = usePatchPropertyVehicleMutation(propertyId);

	const { form, onSubmit, leaveConfirmation } = useEditPortfolioForm({
		schema: getCarFormSchema(t),
		defaultValues: mapPropertyToCarForm(property),
		mutate,
		successToast: t(Resources.Portfolio.EditProperty.savedToast, {
			type: t(Resources.Portfolio.AddItem.Items.auto),
		}),
		redirectTo: detailRoute,
		isPending,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending, leaveConfirmation };
};
